import { Link } from "react-router-dom";
import { getCategory, formatDate } from "@/lib/site";

export const ArticleCard = ({ article, size = "md", index = 0 }) => {
  const cat = getCategory(article.categorySlug);
  const big = size === "lg";
  return (
    <article
      data-testid={`article-card-${article.slug}`}
      className="group fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <Link to={`/articulo/${article.slug}`} className="block">
        <div className={`relative overflow-hidden rounded-md mb-4 ${big ? "aspect-[16/10]" : "aspect-[3/2]"}`}>
          <img
            src={article.image}
            alt={article.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-3 left-3 bg-brand-surface/95 text-brand-ink text-[10px] uppercase tracking-[0.18em] px-3 py-1 rounded-full font-semibold">
            {cat?.short}
          </span>
        </div>
        <h3
          className={`font-heading font-semibold leading-tight text-brand-ink transition-colors group-hover:text-brand-terra ${
            big ? "text-3xl sm:text-4xl" : "text-xl sm:text-2xl"
          }`}
        >
          {article.title}
        </h3>
        <p className={`text-brand-sub mt-2 leading-relaxed ${big ? "text-base" : "text-sm line-clamp-2"}`}>
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 mt-3 text-xs text-brand-sub/80">
          <span>{formatDate(article.date)}</span>
          <span>·</span>
          <span>{article.readingTime} min de lectura</span>
        </div>
      </Link>
    </article>
  );
};
